import axios from "axios";
import Cookies from "universal-cookie";

const { REACT_APP_BASE_URL, REACT_APP_CLIENT_ID } = process.env;

const cookies = new Cookies();

const createAxiosInstance = (baseURL) => {
  return axios.create({
    baseURL: baseURL,
    headers: {
      client_id: REACT_APP_CLIENT_ID,
      access_token: cookies.get("access_token"),
      user_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  });
};

const preTokenApi = createAxiosInstance(REACT_APP_BASE_URL);

//Interceptors
const applyAccessTokenInterceptor = (apiInstance) => {
  apiInstance.interceptors.request.use(
    (req) => {
      const token = cookies.get("access_token");
      if (token) {
        req.headers["access_token"] = token; // Set Access Token
      }
      return req;
    },
    (err) => {
      return Promise.reject(err);
    }
  );

  apiInstance.interceptors.response.use(
    (req) => {
      return req;
    },
    (err) => {
      return Promise.reject(err);
    }
  );
};

applyAccessTokenInterceptor(preTokenApi);


export const getUserProfile = () =>
  new Promise((resolve, reject) => {
    preTokenApi
      .get(`/v2/user/preference`)
      .then((response) => {
        resolve({ status: "success", data: response.data?.data });
      })
      .catch((error) => {
        console.error(error.response)
        reject(error.response);
      });
  });

export const getUserFullProfile = () =>
  new Promise((resolve, reject) => {
    preTokenApi
      .post(`/v1/user/getuserfullprofile`)
      .then((response) => {
        resolve({ status: "success", data: response.data?.data });
      })
      .catch((error) => {
        console.error(error.response)
        reject(error.response);
      });
  });

export const searchHTUsers = (requestData) =>
  new Promise((resolve, reject) => {
    preTokenApi
      .post(`/v3/diagnostics/search-users`, requestData)
      .then((response) => {
        resolve({ status: "success", data: response.data.data });
      })
      .catch((error) => {
        reject(error.response?.data);
      });
  });

export const registerGenebox = (requestData) =>
  new Promise((resolve, reject) => {
    preTokenApi
      .post(`/v3/diagnostics/gene-box/kit/order`, requestData)
      .then((response) => {
        resolve({ status: "success", data: response.data.data });
      })
      .catch((error) => {
        reject(error.response?.data);
      });
  });

/* Di Kit */

export const getDiKitList = (requestData) =>
  new Promise((resolve, reject) => {
    preTokenApi
      .get(`/v3/diagnostics/kit`, { params: requestData })
      .then((response) => {
        resolve({ status: "success", data: response.data.data });
      })
      .catch((error) => {
        reject(error.response?.data);
      });
  });

export const getDiKitData = (requestData) =>
  new Promise((resolve, reject) => {
    preTokenApi
      .get(`/v3/diagnostics/kit/${requestData}`)
      .then((response) => {
        resolve({ status: "success", data: response.data.data });
      })
      .catch((error) => {
        reject(error.response?.data);
      });
  });

export const getDiOrderData = (requestData) =>
  new Promise((resolve, reject) => {
    preTokenApi
      .get(`/v3/diagnostics/order`, { params: requestData })
      .then((response) => {
        resolve({ status: "success", data: response.data.data });
      })
      .catch((error) => {
        reject(error.response?.data);
      });
  });

/* Premium User Get */

export const getHumanTokenUsersList = (requestData) =>
  new Promise((resolve, reject) => {
    preTokenApi
      .get(`/v3/diagnostics/premium/user`, { params: requestData })
      .then((response) => {
        resolve({ status: "success", data: response.data.data });
      })
      .catch((error) => {
        reject(error.response?.data);
      });
  });

export const getHumanTokenUserData = (requestData) =>
  new Promise((resolve, reject) => {
    preTokenApi
      .get(`/v3/diagnostics/premium/user/${requestData}`)
      .then((response) => {
        resolve({ status: "success", data: response.data.data });
      })
      .catch((error) => {
        reject(error.response?.data);
      });
  });

export { preTokenApi };
